import { render } from "./figure-image.vue?vue&type=template&id=8a431570&scoped=true"
import script from "./figure-image.vue?vue&type=script&lang=js"
export * from "./figure-image.vue?vue&type=script&lang=js"

import "./figure-image.vue?vue&type=style&index=0&id=8a431570&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8a431570"

export default script